// extracted by mini-css-extract-plugin
module.exports = {"time":"style_time__2sGUq","timeContainer":"style_timeContainer__ZiSUr"};